import React from 'react'
import CMSMenuWithLayout from './CMSMenuWithLayout';
import Img from '../../assets/images/background/banner-image-2.jpg'

function Menutwo() {
  return (
    <CMSMenuWithLayout
      categoryFilter="pizza"
      title="PIZZA PERFECTION"
      subtitle="Authentic Italian Flavors"
      bannerImage={Img}
      showOffers={false}
      showReservation={true}
    />
  )
}

export default Menutwo